import { FormControl, InputLabel, Select, Stack } from '@mui/material'
import PageSection from '../../Constants&Theme/PageSection'
import {
  listFromKV,
  listItemsFromDataObjectArr,
} from '../../Functions/ListItemGenerator'
import { useMachineContext } from '../../Contexts/CurrentMachine'
import { useGetCodeSet, useGetKVCodeSet } from '../../APIs/Hooks/CodeSetHooks'
import { stackGap } from '../../Constants&Theme/Spacing'

function PrinterSettings() {
  const { cardPrinter, setCardPrinter, officePrinter, setOfficePrinter } =
    useMachineContext()
  const { data: printerData, isLoading: printerLoading } =
    useGetKVCodeSet('KV-Printers')
  const { data: officePrinterData, isLoading: officePrinterLoading } =
    useGetCodeSet('OfficePrinterID')

  const printers = listFromKV(printerData, printerLoading, cardPrinter)
  const officePrinters = listItemsFromDataObjectArr(
    officePrinterData,
    'CodeValue',
    'CodeValue',
    'CodeDescription',
    'reqSortOrder',
    officePrinterLoading,
    officePrinter,
  )

  return (
    <PageSection title={'Printer Settings'}>
      <Stack
        width={1}
        gap={stackGap.col}
      >
        <FormControl fullWidth>
          <InputLabel>Card Printer</InputLabel>
          <Select
            aria-label={'Card Printer'}
            label="Card Printer"
            name="cardPrinter"
            value={cardPrinter}
            onChange={(e) => setCardPrinter(e.target.value)}
          >
            {printers}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>Office Printer</InputLabel>
          <Select
            aria-label={'Office Printer'}
            label="Office Printer"
            name="officePrinter"
            value={officePrinter}
            onChange={(e) => setOfficePrinter(e.target.value)}
          >
            {officePrinters}
          </Select>
        </FormControl>
      </Stack>
    </PageSection>
  )
}

export default PrinterSettings
